<template>
  <div>    
    <main-content right-sidebar="true">
      <transition-group
        @before-enter="beforeEnter"
        @enter="enter"
        @afterEnter="afterEnter"
        @beforeLeave="beforeLeave"
        @leave="leave"
        @afterLeave="afterLeave"
      >
        <div
          v-for="(tag, index) in filteredActiveTags"
          :key="tag._id"
          :data-index="index"
        >
          <tag-basic
            v-if="tag.type === 'tag'"
            v-bind="tag.marker"
            :pos="{ 
              x: tag.marker.x,
              y: tag.marker.y
            }"
            :show-sold-label="showSoldLabel(tag)"
            :label="{ en: isSoldOut(tag) ? tag.label : tag.label + '<br>now selling' }"
            :style="`transform: rotate(${tag.marker.rotation}deg); opacity: ${tag.marker.opacity};`"
            @click.native="$router.push(tag.to)"
          />

          <availability-marker
            v-if="tag.type === 'dot'"
            class="touch"
            :x="tag.marker.x"
            :y="tag.marker.y"
            :status="tag.status"
            @click.native="$router.push(tag.to)"
          />

          <polygon-shape
            v-if="tag.polygon && tag.polygon.points.length"
            :polygon="tag.polygon"
            :to="tag.to"
          />
        </div>
      </transition-group>
    </main-content>
  </div>
</template>
<script>
import AvailabilityMarker from '@/components/AvailabilityMarker'
import MainContent from '@/components/MainContent'
import PolygonShape from '@/components/PolygonShape'
import TagBasic from '@/components/TagBasic'
import { bus } from '../main'
import _ from 'lodash'

export default {
  props: ['tags', 'to'],

  components: { AvailabilityMarker, MainContent, PolygonShape, TagBasic },

  data () {
    return {
      activeTags: []
    }
  },

  computed: {
    filteredActiveTags () {
      return this.activeTags.filter(tag => !tag.isVisuallyHidden)
    },

    styleTemplate () {
      return this.$store.state.styleTemplate
    }
  },

  watch: {
    tags (newTags, oldTags) {
      if (!_.isEqual(oldTags, newTags)) {
        this.activeTags = []
        if (newTags && newTags.length) {
          this.$store.commit('addAnimationToQueue', 'MasterplanTags')
        }
      }
    }
  },

  mounted () {
    bus.$on('animateMasterplanTags', () => {
      if (!_.isEqual(this.activeTags, this.tags)) {
        this.activeTags = this.tags
      } else {
        bus.$emit('finishedAnimation')
      }
    })
  },

  methods: {
    handleNavigation (tag) {
      console.log(tag.to)
      this.$router.push(tag.to)
    },

    isSoldOut (tag) {
      return tag.isSoldOut
    },
    
    showSoldLabel (tag) {
      return this.styleTemplate['general']['show-sold-label'] && this.isSoldOut(tag)
    },

    beforeEnter (el) {
      el.removeAttribute('style')
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
    },

    enter (el, done) {
      setTimeout(() => {
        el.style.opacity = 1
        el.style.transform = 'translateY(0)'
        el.style.transition = `transform 0.6s cubic-bezier(0.33, 1, 0.68, 1), opacity 1.2s`
        setTimeout(() => {
          done()
        }, 300)
      }, (parseInt(el.dataset.index) + 1) * 150)
    },

    afterEnter (el) {
      if (parseInt(el.dataset.index) + 1 === this.tags.length) {
        bus.$emit('finishedAnimation')
      }      
      el.removeAttribute('style')
    },

    beforeLeave (el) {
      el.style.transition = `transform 0.3s cubic-bezier(0.32, 0, 0.67, 0), opacity 0.3s`
    },

    leave (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
    },

    afterLeave (el) {
      el.removeAttribute('style')
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
